var chunkMapping = {
	"197": [
		60197
	],
	"900": [
		20900
	],
	"1366": [
		71366
	],
	"1438": [
		71438
	],
	"2009": [
		32009
	],
	"3797": [
		83797
	],
	"4631": [
		64631
	],
	"4920": [
		74920
	],
	"5864": [
		65864
	],
	"7261": [
		27261
	],
	"8873": [
		28873
	],
	"9041": [
		69041
	],
	"9205": [
		69205
	]
};
var idToExternalAndNameMapping = {
	"20900": [
		"default",
		"./Routes",
		86261
	],
	"27261": [
		"default",
		"./Routes",
		71815
	],
	"28873": [
		"default",
		"./Routes",
		51907
	],
	"32009": [
		"default",
		"./Routes",
		56155
	],
	"60197": [
		"default",
		"./Routes",
		89179
	],
	"64631": [
		"default",
		"./Routes",
		12899
	],
	"65864": [
		"default",
		"./Routes",
		96989
	],
	"69041": [
		"default",
		"./Routes",
		11363
	],
	"69205": [
		"default",
		"./Routes",
		55281
	],
	"71366": [
		"default",
		"./Routes",
		89613
	],
	"71438": [
		"default",
		"./Routes",
		48517
	],
	"74920": [
		"default",
		"./Routes",
		32789
	],
	"83797": [
		"default",
		"./Routes",
		90801
	]
};
var idToRemoteMap = {
	"20900": [
		{
			"externalType": "script",
			"name": "invoices"
		}
	],
	"27261": [
		{
			"externalType": "script",
			"name": "contacts"
		}
	],
	"28873": [
		{
			"externalType": "script",
			"name": "insights"
		}
	],
	"32009": [
		{
			"externalType": "script",
			"name": "settings"
		}
	],
	"60197": [
		{
			"externalType": "script",
			"name": "planning"
		}
	],
	"64631": [
		{
			"externalType": "script",
			"name": "quotations"
		}
	],
	"65864": [
		{
			"externalType": "script",
			"name": "workorders"
		}
	],
	"69041": [
		{
			"externalType": "script",
			"name": "expenses"
		}
	],
	"69205": [
		{
			"externalType": "script",
			"name": "deals"
		}
	],
	"71366": [
		{
			"externalType": "script",
			"name": "projects"
		}
	],
	"71438": [
		{
			"externalType": "script",
			"name": "calendar"
		}
	],
	"74920": [
		{
			"externalType": "script",
			"name": "aiAssistant"
		}
	],
	"83797": [
		{
			"externalType": "script",
			"name": "companies"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"20900": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 86261,
		"remoteName": "invoices"
	},
	"27261": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 71815,
		"remoteName": "contacts"
	},
	"28873": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 51907,
		"remoteName": "insights"
	},
	"32009": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 56155,
		"remoteName": "settings"
	},
	"60197": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 89179,
		"remoteName": "planning"
	},
	"64631": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 12899,
		"remoteName": "quotations"
	},
	"65864": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 96989,
		"remoteName": "workorders"
	},
	"69041": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 11363,
		"remoteName": "expenses"
	},
	"69205": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 55281,
		"remoteName": "deals"
	},
	"71366": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 89613,
		"remoteName": "projects"
	},
	"71438": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 48517,
		"remoteName": "calendar"
	},
	"74920": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 32789,
		"remoteName": "aiAssistant"
	},
	"83797": {
		"shareScope": "default",
		"name": "./Routes",
		"externalModuleId": 90801,
		"remoteName": "companies"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}